import React from "react";
import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <div className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-links">
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/terms-and-conditions">Terms of Service</Link>
          </div>
          <p className="footer-copyright">
            &copy; {new Date().getFullYear()} Peak Risk Management. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};
